import { EmailIntegrationTable } from 'features/settings/components/EmailIntegrationTable'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { Navigate } from 'react-router-dom'

export function EmailIntegrationSettingsPage() {
  const featureFlags = useFeatureFlagService()

  if (!featureFlags.enableEmailIntegration) {
    return <Navigate to="/settings/team/users" replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <EmailIntegrationTable />
    </div>
  )
}
